/**
 * src/main.jsx
 * Entry point ของ React application
 * Mount App component ลง DOM
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { bootstrapAnalytics } from './utils/bootstrapAnalytics.js';
import './index.css';

bootstrapAnalytics();

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
